import { Routes } from '@angular/router';

import { LoginRoutes } from './login/login.routes';
import { SignupRoutes } from './signup/signup.routes';
import { DashboardRoutes } from './dashboard/dashboard.routes';

import { LoginComponent } from './login/index';
import { RpwRoutes } from './resetPassword';
import { SecRoutes } from './sec/sec.routes';

export const routes: Routes = [
  ...LoginRoutes,
  ...SignupRoutes,
  ...SecRoutes,
  ...RpwRoutes,
  //  ...DashboardRoutes,
  {
    path: '**', component: LoginComponent
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts